export default __webpack_public_path__ + "static/media/leg-left-front.abb6be48.png";